import React from 'react';
import {
  FlexGrid,
  getRehydratableName,
  Heading,
  Rank,
  getClassNameFactory,
} from '@dcl/ui';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import { types, boldTypes } from '@dcl/ui/dist/elements/Heading';
import { IContactUsHeaderProps } from './ContactUsHeader.props';
import ContactUsIcon from './ContactUsIcon';
import './index.css';

const ContactUsHeader: React.FC<IContactUsHeaderProps> = (props) => {
  const { title } = props;
  const dataAttributes = propsToDataAttributes(props);
  const getClassName = getClassNameFactory(ContactUsHeader.displayName);

  return (
    <div
      className={getClassName()}
      data-rehydratable={getRehydratableName(ContactUsHeader.displayName)}
      {...dataAttributes}
    >
      <FlexGrid className={getClassName({ descendantName: 'container' })}>
        <FlexGrid.Row>
          <FlexGrid.Col
            sm={12}
            className={getClassName({ descendantName: 'header' })}
          >
            {ContactUsIcon}
            <Heading
              type={types.Medium}
              boldType={boldTypes.black}
              rank={Rank.Second}
            >
              <span className={getClassName({ descendantName: 'title' })}>
                {title}
              </span>
            </Heading>
          </FlexGrid.Col>
        </FlexGrid.Row>
      </FlexGrid>
    </div>
  );
};

ContactUsHeader.displayName = 'ContactUsHeader';

export default ContactUsHeader;
